// Uppy's Dashboard moves keyboard focus into itself after every render ("superFocus"). Once a
// file has been added there is nothing better to focus, so it lands on the file's cancel/remove
// button and paints a focus ring the user never asked for. Uppy has no option for this, so the
// Dashboard's (undocumented) superFocus hook is wrapped to only run while the user is navigating
// with the keyboard, where moving focus into the dashboard is actually helpful.

let lastInputWasKeyboard = false;
let listening = false;

function listenForInputModality() {
    if(listening) {
        return;
    }
    listening = true;
    window.addEventListener('keydown', () => { lastInputWasKeyboard = true; }, true);
    window.addEventListener('pointerdown', () => { lastInputWasKeyboard = false; }, true);
}

export function limitDashboardFocusToKeyboard(uppy) {
    const dashboard = uppy.getPlugin('Dashboard');
    if(!dashboard || typeof dashboard.superFocus !== 'function') {
        return;
    }
    listenForInputModality();

    const superFocus = dashboard.superFocus;
    const guarded = (...args) => {
        if(lastInputWasKeyboard) {
            superFocus(...args);
        } else {
            superFocus.cancel();
        }
    };
    guarded.cancel = () => superFocus.cancel();
    dashboard.superFocus = guarded;
}
